import React from 'react';
import { Card, List, Tag, Button, Empty, Typography, Space } from 'antd';
import { ClockCircleOutlined, EnvironmentOutlined, TeamOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { Text } = Typography;

// Uma linha = uma (Sessao, Matricula) elegivel -- mesma identidade do
// backend (evento_inscricao_portal_service.listar_oportunidades_portal),
// nunca deduplicada por aluno: um mesmo aluno com 2 matriculas elegiveis
// aparece em 2 linhas independentes, cada uma com sua propria acao.
const EventosDisponiveisList = ({ oportunidades = [], loading, solicitandoKey, cancelandoKey, onSolicitar, onCancelar }) => {
  const renderVagas = (oportunidade) => {
    if (oportunidade.capacidade_total === null || oportunidade.capacidade_total === undefined) {
      return <Tag color="blue">Vagas ilimitadas</Tag>;
    }
    if (oportunidade.esgotado) {
      return <Tag color="red">Esgotado</Tag>;
    }
    return <Tag color="green">{oportunidade.vagas_disponiveis} vaga(s)</Tag>;
  };

  const renderAcao = (oportunidade) => {
    const chave = `${oportunidade.id_evento_sessao}-${oportunidade.id_matricula}`;

    if (oportunidade.inscricao_status === 'APROVADA') {
      return <Tag color="green">Aprovada</Tag>;
    }
    if (oportunidade.inscricao_status === 'SOLICITADA') {
      return (
        <Button
          danger
          size="small"
          loading={cancelandoKey === oportunidade.inscricao_id}
          onClick={() => onCancelar?.(oportunidade)}
        >
          Cancelar solicitação
        </Button>
      );
    }
    if (oportunidade.esgotado) {
      return (
        <Button size="small" disabled>
          Esgotado
        </Button>
      );
    }
    return (
      <Button
        type="primary"
        size="small"
        loading={solicitandoKey === chave}
        onClick={() => onSolicitar?.(oportunidade)}
      >
        Solicitar inscrição
      </Button>
    );
  };

  return (
    <Card title="Eventos disponíveis" bordered={false} style={{ marginBottom: 24 }}>
      <List
        dataSource={oportunidades}
        loading={loading}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Nenhum evento disponível no momento"
            />
          ),
        }}
        renderItem={(oportunidade) => (
          <List.Item
            key={`${oportunidade.id_evento_sessao}-${oportunidade.id_matricula}`}
            actions={[renderAcao(oportunidade)]}
          >
            <List.Item.Meta
              title={
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Text strong>{oportunidade.evento_nome}</Text>
                  <Text type="secondary">{oportunidade.sessao_nome}</Text>
                </div>
              }
              description={
                <Space direction="vertical" size={4}>
                  <Text type="secondary">
                    <ClockCircleOutlined style={{ marginRight: 6 }} />
                    {dayjs(oportunidade.data).format('DD/MM/YYYY')} às{' '}
                    {String(oportunidade.hora_inicio).slice(0, 5)}
                  </Text>
                  {oportunidade.local && (
                    <Text type="secondary">
                      <EnvironmentOutlined style={{ marginRight: 6 }} />
                      {oportunidade.local}
                    </Text>
                  )}
                  <Text type="secondary">
                    <TeamOutlined style={{ marginRight: 6 }} />
                    {oportunidade.nome_aluno} — {oportunidade.turma_origem_nome}
                  </Text>
                </Space>
              }
            />
            {renderVagas(oportunidade)}
          </List.Item>
        )}
      />
    </Card>
  );
};

export default EventosDisponiveisList;
